import styled from 'styled-components';

export const Box = styled.div`
  padding: 24px 27px;

  button {
    background: #549a9a;
    width: 100%;
    border: none;
    outline: none;
    color: #fff;
    border-radius: 8px;
    padding: 14px;
    margin-top: 104px;
    font-weight: 700;
    font-size: 16px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    color: #003232;
    font-size: 24px;
    font-weight: 500;
  }

  .clear {
    font-size: 12px;
    font-weight: 500;
    color: #549a9a;
    cursor: pointer;
  }
`;

export const Categories = styled.div`
  margin-top: 48px;

  .title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .category {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .container {
    display: flex;
    gap: 16px;
    align-items: center;
    cursor: pointer;
  }

  .checkbox {
    width: 13px;
    height: 13px;
    border: 1px solid #549a9a;
    border-radius: 2px;
    cursor: pointer;
    display: grid;
    place-items: center;
  }

  .checkbox_selected {
    width: 13px;
    height: 13px;
    border: 1px solid #549a9a;
    border-radius: 2px;
    cursor: pointer;
    display: grid;
    place-items: center;
    background: #549a9a;
  }

  .name {
    color: #003232;
    font-size: 12px;
    font-weight: 500;
  }

  .show {
    font-size: 10px;
    color: #549a9a;
    font-weight: 400;
    padding-left: 30px;
    cursor: pointer;
  }
`;

export const Price = styled.div`
  margin-top: 32px;

  .title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .container {
    display: flex;
    gap: 16px;
    align-items: center;
    cursor: pointer;
  }

  .checkbox {
    width: 13px;
    height: 13px;
    border: 1px solid #549a9a;
    border-radius: 2px;
    cursor: pointer;
    display: grid;
    place-items: center;
  }

  .checkbox_selected {
    width: 13px;
    height: 13px;
    border: 1px solid #549a9a;
    border-radius: 2px;
    cursor: pointer;
    display: grid;
    place-items: center;
    background: #549a9a;
  }

  .name {
    color: #003232;
    font-size: 12px;
    font-weight: 500;
  }
`;
